import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { statusMapping } from './status-card.constants';

@Component({
  selector: 'pp-status-card',
  imports: [TranslateModule],
  templateUrl: './status-card.component.html',
  styleUrl: './status-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusCardComponent {
  @HostBinding('class') hostClasses = '';

  statusText: string;

  @Input() set status(status: string) {
    this.statusText = status;

    this.hostClasses = statusMapping.get(status);
  }
}
